import React from 'react';
import PropTypes from 'prop-types';
import { manageEventListener } from '../../../common/utils';
import withLocalization from '../../higherOrderComponents/withLocalization';
import { UnorderedList } from '../UnorderedList';
import { allowedMessageProps } from './_allowedPropTypes';
import MessageListItem from './_MessageListItem';

class MessageListArea extends React.Component {
  constructor() {
    super();
    this.state = {
      messages: [],
      lastMessage: {},
      lastBulkDismiss: new Date()
    };

    this.pushMessage = this.pushMessage.bind(this);
    this.removeMessage = this.removeMessage.bind(this);
    this.dismissAllMessages = this.dismissAllMessages.bind(this);
    this.handleKeyUpEvent = this.handleKeyUpEvent.bind(this);
    this.manageEventListeners = this.manageEventListeners.bind(this);
  }

  componentDidMount() {
    const {
      pushMessage,
      manageEventListeners
    } = this;

    pushMessage();
    manageEventListeners('add');
  }

  componentDidUpdate() {
    const {
      props: {
        lastBulkDismiss: newBulkDismissDate
      },
      state: {
        lastBulkDismiss: oldBulkDismissDate
      },
      pushMessage,
      dismissAllMessages
    } = this;

    pushMessage();

    if (newBulkDismissDate && newBulkDismissDate.getTime() > oldBulkDismissDate.getTime()) {
      dismissAllMessages(newBulkDismissDate);
    }
  }

  componentWillUnmount() {
    this.manageEventListeners('remove');
  }

  pushMessage() {
    const {
      props: {
        newMessage
      },
      state: {
        lastMessage
      }
    } = this;

    if (newMessage && lastMessage.id !== newMessage.id) {
      this.setState(({ messages: previousMessages }) => ({
        messages: [...previousMessages, newMessage],
        lastMessage: newMessage
      }));
    }
  }

  removeMessage(deletedMessageId) {
    this.setState(({ messages: previousMessages }) => ({
      messages: previousMessages.filter(({ id }) => id !== deletedMessageId)
    }));
  }

  dismissAllMessages(newBulkDismissDate) {
    this.setState(({ messages: previousMessages }) => ({
      messages: previousMessages.map(message => ({ ...message, bulkDismissed: true })),
      lastBulkDismiss: newBulkDismissDate || new Date()
    }));
  }

  handleKeyUpEvent({ key }) {
    if (key === 'Escape') {
      this.dismissAllMessages();
    }
  }

  manageEventListeners(action) {
    manageEventListener(document, 'keyup', action, this.handleKeyUpEvent);
  }

  render() {
    const {
      props: {
        translate
      },
      state: {
        messages
      },
      removeMessage
    } = this;

    return messages.length < 1 ? null : (
      <UnorderedList
        title={translate('list-title')}
        htmlAttributes={{ className: 'area-system-message-list' }}
      >
        {messages.map(attributes => {
          const {
            id,
            bulkDismissed
          } = attributes;

          return (
            <MessageListItem
              {...attributes}
              key={id}
              removeFromMessageList={() => removeMessage(id)}
              bulkDismissed={bulkDismissed}
            />
          );
        })}
      </UnorderedList>
    );
  }
}

MessageListArea.propTypes = {
  newMessage: PropTypes.shape(allowedMessageProps),
  lastBulkDismiss: PropTypes.instanceOf(Date)
};

export default withLocalization(MessageListArea, 'lists/systemMessages');